import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Field } from 'react-final-form';
import css from './FieldNumberInput.module.css';

const FieldNumberInputComponent = props => {
  const { rootClassName, className, id, label, input, meta, minValue, maxValue, ...rest } = props;

  const initialValue = minValue !== undefined ? minValue : 0;
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    if (input.value === '') {
      input.onChange(initialValue);
    }
  }, [initialValue, input]);

  const increment = () => {
    if (maxValue === undefined || value < maxValue) {
      setValue(value + 1);
      input.onChange(value + 1);
    }
  };

  const decrement = () => {
    if (value > minValue) {
      setValue(value - 1);
      input.onChange(value - 1);
    }
  };

  const { touched, error } = meta;
  const hasError = touched && error;

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div className={css.container}>
        <div className={css.labelWrapper}>
          {label ? <span className={css.label}>{label}:</span> : null}
        </div>
        <div className={css.inputWrapper}>
          <button type="button" className={css.button} onClick={decrement}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="23"
              height="23"
              viewBox="0 0 23 23"
              fill="none"
            >
              <circle cx="11.5" cy="11.5" r="11.5" fill="#E8E8E8" />
              <line x1="7" y1="11.5" x2="16" y2="11.5" stroke="black" />
            </svg>
          </button>
          <input {...input} {...rest} id={id} value={value} readOnly className={css.input} />
          <button type="button" className={css.button} onClick={increment}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="23"
              height="23"
              viewBox="0 0 23 23"
              fill="none"
            >
              <circle cx="11.5" cy="11.5" r="11.5" fill="#E8E8E8" />
              <line x1="7" y1="11.5" x2="16" y2="11.5" stroke="black" />
              <line x1="11.5" y1="7" x2="11.5" y2="16" stroke="black" />
            </svg>
          </button>
        </div>
      </div>
      {hasError ? <span className={css.error}>{error}</span> : null}
    </div>
  );
};

FieldNumberInputComponent.defaultProps = {
  rootClassName: null,
  className: null,
  id: null,
  label: null,
  minValue: 0,
  maxValue: undefined,
};

FieldNumberInputComponent.propTypes = {
  rootClassName: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
};

const FieldNumberInput = props => {
  return <Field component={FieldNumberInputComponent} {...props} />;
};

export default FieldNumberInput;
